<template>
<div class="product is-flex-tablet mb30">
  <div class="product-image has-text-centered">
    <div class="product-img-wrapper" v-if="product.images && product.images.length > 0">
      <carousel :autoplay="true" :autoplayTimeout="parseInt(13000)" :nav="false" :items="1" :dots="true" ><!-- 10000 kind of not working on realtime -->
        <div class="location-product-carousel-img-wrapper"  v-for="(img, index) in product.images" v-bind:key="'img_' + index">
          <img :src="img.product_image" :alt="product.name">
        </div>
      </carousel>
    </div>
    <img v-else src="@/assets/img/leaf.png" class="default-thumb" :alt="product.name" />
  </div>
  <div class="product-details" v-if="product">
    <div class="company-name is-uppercase brand-display-with-out-of-stock" v-if="product.brandName && (product.brandName != 'No Brand')">{{ product.brandName }} <span class="brand-display-outofstock bg-primary" v-if="totalNumberOfAddableVariants == 0">OUT OF STOCK</span><span class="brand-display-outofstock product-detail-sale-tag" v-else-if="productOnSale">{{ productOnSalePercentage }}</span></div>
    <div class="product-name is-flex justify-content-between has-text-weight-bold mb10">
      <span v-text="product.name"></span>
      <a href="#" v-if="isGuest == false" @click.prevent="isFavProduct ? unFavouriteProduct() : favouriteProduct()" :class="isFavProduct ? ' fav-product' : ''">
        <i :class="isFavProduct ? 'fas fav-btn fa-heart' : 'far fav-btn fa-heart'"></i>
      </a>
    </div>
    <div class="product-desc" v-html="product.desc"></div>
  </div>
</div>
</template>

<script>
import UserApis from '@/Components/Controllers/UserApis';
import carousel from 'vue-owl-carousel';
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';

export default {
  name: 'ProductDetailDescription',
  components: { carousel },
  data() {
    return {
      totalNumberOfAddableVariants: 0,
      productOnSale: false,
      productOnSalePercentage: false,
    };
  },
  
  props: ['product'],

  computed: {

    ...mapGetters({
      vg_selectedLocation: "location/selected",
      vg_favProducts: "favouriteproducts/list",
      vg_guestLandedQueries: "location/guestLandedQueries",
    }),

    isGuest() {
      if(this.$store.getters.getLoggedInUserToken != ''){
        return false; 
      } else {
        if(this.vg_guestLandedQueries['guest-only'] == 'true' || this.$route.query['guest-only']){
          return true;
        }
      }
      return false;
    },

    isFavProduct() {
      const self = this;
      let favObj = _.find(this.vg_favProducts, function(o) { return o.id == self.$route.params.product_id; });
        if(favObj != undefined){
          this.favDetail = favObj;
          return true;
        }
        return false;
    },

  },

  mounted() {
    this.totalNumberOfAddableVariants = Helpers.getTotalNumberOfAddableVariants(this.product.variants);
    if(this.product.variants[0] && this.product.variants[0].price){
      if(this.product.variants[0].sale_price && this.product.variants[0].sale_price < this.product.variants[0].price){
        this.productOnSale = true;
        let salePercentData = ((this.product.variants[0].price-this.product.variants[0].sale_price) / this.product.variants[0].price)*100;
        this.productOnSalePercentage = ((salePercentData - Math.floor(salePercentData)) ? salePercentData.toFixed(0) : salePercentData) + '% off';
      } 
    } 
  },

  
  methods: {

     /**
     * Fav product
     */
    async favouriteProduct() {
      if(!this.$store.getters.getLoggedInUserId){
        this.va_snackbar({
          message: "Please login to proceed.",
          type: "warning",
        })
        return;  
      }
      this.va_spinner(true);
      let res = await UserApis.addFavProduct({
        location_id: this.vg_selectedLocation.id,
        location_product_id: this.$route.params.product_id
      });
      this.va_spinner(false);
      this.va_snackbar({
        message: res.status == 201 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        type: res.status == 201 ? 'success' : 'error',
      });
    },

    /**
     * Unfav product
     */
    async unFavouriteProduct() {
      if(!this.$store.getters.getLoggedInUserId){
        this.va_snackbar({
          message: "Please login to proceed.",
          type: "warning",
        })
        return;
      }
      this.va_spinner(true);
      console.log('hit unfav')
      let res = await UserApis.removeFavProduct({
        location_id: this.vg_selectedLocation.id,
        location_product_id: this.$route.params.product_id
      });
      this.va_spinner(false);
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        type: res.status == 200 ? 'success' : 'error',
      });
    },

     ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })

  },
};
</script>

<style scoped>
.product-img-wrapper {
  width: 250px;
}
.default-thumb{
  max-width: 200px;
  width: auto
}
.location-product-carousel-img-wrapper {
  max-height: 300px;
  text-align: center;
}
.location-product-carousel-img-wrapper img{
  max-height: 300px;
  width: auto !important;
  display: inline-block
}
</style>

